var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgTyperightDown = function SvgTyperightDown(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.53 7.334a.5.5 0 0 0-.449.497v9.543L5.854 5.146a.522.522 0 0 0-.079-.064.5.5 0 0 0-.629.772L17.374 18.08H7.831a.5.5 0 1 0 0 1h10.75c.018 0 .035 0 .052-.002a.5.5 0 0 0 .448-.498V7.831a.5.5 0 0 0-.55-.497Z",
    fill: "currentColor"
  })));
};
export { SvgTyperightDown as ReactComponent };
export default __webpack_public_path__ + "74dc3684e996cc07a106a01f66fc2553.svg";